import React, { useEffect, useState } from "react";
import Menu from "@/components/menu";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItem from "@mui/material/ListItem";
import Header from "./header";
import * as styles from "./style.module.scss";
import {
  setNotificationsToState,
  selectNotifications,
  setMarkAsRead,
  getStaticExportName,
  getPageInfo,
} from "@/store/slices/notifications/notificationsSlice";
import { useDispatch, useSelector } from "react-redux";
import Link from "next/link";
import NestedMessage from "./nested-message";
import NotificationLabel from "./notification-labels";
import NotificationHeading from "./notification-heading";
import NotificationText from "./notification-text";
import NotificationStatusTrigger from "./notification-status-trigger";
import NotificationAvatar from "./notification-avatar";
import Badge from "@mui/material/Badge";
import ListSubheader from "@mui/material/ListSubheader";
import Lead_signalr from "@/modules/crm/leads/signalr-constants";
import useSignalRClient from "@/services/signal-R/signalr-hubs";
import useLeadNotifications from "@/hooks/leads/useLeadNotifiaction";
import { exportLeads } from "@/store/slices/lead/leadSlice";
import { useRouter, usePathname } from "next/navigation";
import { getLoggedinUser } from "@/store/slices/auth/authSlice";
import moment from "moment";
import UIButton from "@/components/ui-controls/button";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import Box from "@mui/material/Box";
import TruncateTooltip, {
  TooltipComponent,
} from "@/components/truncate-with-tooltip";

const NotificationMenu = ({ anchorEl, isMenuOpen, handleMenuClose }) => {
  const router = useRouter();
  const path = usePathname();
  const { getNotifications } = useLeadNotifications();
  const {
    hubName,
    InvokeMethodNames: { markNotificationAsRead },
  } = Lead_signalr;

  const { statuses, RTC } = useSignalRClient({ hubName });
  const leadhub = RTC[hubName];
  const leadhubStatus = statuses[hubName];
  const [loading, setLoading] = useState(false);
  const [selectedOpt, setSelectedOpt] = useState("direct");
  const dateGroups = [
    "Today",
    "Yesterday",
    "Earlier this Week",
    "Last Week",
    "Other",
  ];
  const { notifications } = useSelector(selectNotifications);
  const pageInfo = useSelector(getPageInfo);

  const [filteredNotifications, setFilteredNotifications] = useState([]);

  const dispatch = useDispatch();
  const profile = useSelector(getLoggedinUser);

  const fetchNotifications = () => {
    let payload = {
      where: { userEmail: { eq: profile?.Email } },
      order: [{ id: "DESC" }],
      skip: notifications?.length || pageInfo?.skip,
      take: pageInfo?.take,
    };

    setLoading(true);
    getNotifications(payload).then((response) => {
      let payload = JSON.parse(JSON.stringify(response ?? []));
      payload = payload.map((notification) => {
        return {
          ...notification,
          loggedInUserId: profile?.UserID,
        };
      });
      dispatch(setNotificationsToState(payload));
      setLoading(false);
    });
  };

  useEffect(() => {
    // fetch notifications
    if (profile?.Email) {
      fetchNotifications();
    }
  }, [profile]);

  const handlerFilterNotification = (allNotifications) => {
    const filtered = allNotifications.filter((notification) => {
      if (selectedOpt === "unread") {
        return !notification.isNotificationRead;
      } else if (selectedOpt === "following") {
        return notification.isFollowing;
      } else if (selectedOpt === "direct") {
        return true;
      }
    });
    return filtered;
  };

  // filter data on tab selection
  useEffect(() => {
    const filtered = notifications.filter((notification) => {
      if (selectedOpt === "unread") {
        return !notification.isNotificationRead;
      } else if (selectedOpt === "following") {
        return notification.isFollowing;
      } else if (selectedOpt === "direct") {
        return true;
      }
    });
    setFilteredNotifications(filtered);
  }, [selectedOpt, notifications]);

  const onChangeOption = (event) => {
    let selected = event.currentTarget.name;
    if (event.currentTarget.name === "unread") {
      selected = event.currentTarget.checked ? "unread" : "direct";
    }
    setSelectedOpt(selected);
  };

  // when mark read triggerd
  const handleNotificationIsRead = (id) => {
    leadhub
      .invoke(markNotificationAsRead, {
        id,
      })
      .then((res) => {
        console.log("Request reached to server:: ", res);
      })
      .catch((error) => {
        console.error("Error:: ", res);
      });
  };

  //unfollow a lead
  const handleUnFollowLead = (id) => {
    console.log("UnFollow Lead", id);
  };
  const redirectNotification = (e, notification) => {
    e.preventDefault();
    let route = "/crm/leads";
    handleNotificationIsRead(notification?.id);
    // if (notification?.title.indexOf("Export") > -1) {
    //   getDownloadFile(notification.data);
    // } else
    if (notification?.leadId) {
      route = {
        pathname: `${route}/view/[id]`,
        query: { id: notification.leadId },
      };
      let query = notification?.type?.includes("Email")
        ? "email"
        : "conversation";
      if (notification?.data?.conversationId) {
        route.query[query] = notification?.data?.conversationId;
      }
      router.push(route);
    } else if (
      notification?.type === "WorkflowRun" &&
      path !== "/crm/automation/automations"
    ) {
      router.push("/crm/automation/automations");
    }

    handleMenuClose();
  };

  const getDownloadFile = async (fileName) => {
    let result = await exportLeads(
      fileName,
      true,
      getStaticExportName(fileName)
    );
    // result true means file downloaded successfully
    // do some work after that
    console.log("data", result);
  };

  const menuId = "primary-search-notification-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      id={menuId}
      open={isMenuOpen}
      onClose={handleMenuClose}
      classes={{ paper: styles.notificationMenu }}
      style={{ border: "none" }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Header selected={selectedOpt} onChange={onChangeOption} />
      <List className={`${styles?.listContainer} custom-scroll`}>
        {dateGroups.map(
          (group) =>
            filteredNotifications?.filter((x) => x.dateGroup === group).length >
              0 && (
              <List
                key={group}
                subheader={
                  <ListSubheader
                    style={{
                      color: "var(--palette-sub_heading)",
                      borderBottom: "1px solid var(--palette-stroke)",
                      backgroundColor: "var(--palette-container)",
                    }}
                  >
                    {group}
                  </ListSubheader>
                }
                style={{ paddingBottom: 0 }}
              >
                {filteredNotifications
                  ?.filter((x) => x.dateGroup === group)
                  .map((item, index) => (
                    <ListItem
                      className={styles?.listItemButton}
                      key={index}
                      alignItems="flex-start"
                      divider
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        className={`${styles.statusTrigger}`}
                      >
                        {item?.isFollowing && (
                          <NotificationStatusTrigger
                            isFollowing={true}
                            title={"Unfollow a lead"}
                            notification={item}
                            handleClick={handleUnFollowLead}
                          />
                        )}
                        {!item?.isNotificationRead && (
                          <NotificationStatusTrigger
                            isFollowing={false}
                            title={"Mark as read"}
                            notification={item}
                            handleClick={handleNotificationIsRead}
                          />
                        )}
                      </span>
                      <Link
                        className={styles.notificationLink}
                        href=""
                        onClick={(e) => redirectNotification(e, item)}
                      >
                        <ListItemAvatar>
                          <NotificationAvatar notification={item} />
                        </ListItemAvatar>
                        <div className={styles.nestedNotificationItems}>
                          <ListItemText
                            primary={
                              <NotificationHeading
                                title={
                                  <TruncateTooltip
                                    text={item?.title}
                                    limit={32}
                                  />
                                }
                                text={moment
                                  .utc(item?.createdOn)
                                  .local()
                                  .fromNow()}
                              />
                            }
                            secondary={<NotificationText text={item?.text} />}
                          />

                          {item?.message && (
                            <NestedMessage notification={item} />
                          )}

                          {!!item?.labels?.length &&
                            item?.labels?.map((label, index) => {
                              return (
                                <NotificationLabel label={label} key={index} />
                              );
                            })}
                        </div>
                      </Link>
                    </ListItem>
                  ))}
              </List>
            )
        )}
        {pageInfo?.hasNextPage && filteredNotifications?.length > 0 && (
          <Box textAlign="center" mt={1}>
            <UIButton
              variant="outlined"
              color="primary"
              loading={loading}
              disabled={loading}
              onClick={() => {
                let append = true;
                fetchNotifications(append);
              }}
            >
              Load More
              <KeyboardDoubleArrowDown />
            </UIButton>
          </Box>
        )}
      </List>
    </Menu>
  );
  return renderMenu;
};

export default NotificationMenu;
